import { useState, useEffect, useContext } from 'react';
import { MdArrowBack } from 'react-icons/md';
import { AppContext } from '../App';
import logo_wide from '../assets/logo_wide.png';
import { MdOutlineCancel } from 'react-icons/md';
import { TbSend } from 'react-icons/tb';
import { RiAttachment2 } from 'react-icons/ri';
import { callApi, callGameServerApi } from '../Helpers';
import { ChatContext as CommunityChatContext } from '../views/CommunityChat';
import { ChatContext as ChatRoomChatContext } from '../views/ChatRoom';
import { AiOutlineCaretDown } from 'react-icons/ai';

export default function TypingBox2 (props) {

  const appContext = useContext(AppContext);
  const communityChatContext = useContext(CommunityChatContext);
  const chatRoomChatContext = useContext(ChatRoomChatContext);
  const chatContext = communityChatContext || chatRoomChatContext;

  const [ text, setText ] = useState('');
  const [ lockKeyboard, setLockKeyboard ] = useState(false);
  const [ showHolder, setShowHolder ] = useState(false);

  const sendMessage = async () => {
    let attachment = document.getElementById('__chat_attachment_').files[0];

    if((text && text.trim().length > 0) || attachment) {
      //lock typing
      setLockKeyboard(true);
      let user = await appContext.getLocalUser();
      appContext.setShowOverlayLoader(true);
      await callGameServerApi(
        chatContext.messageSenderUrl, 
        { 
          ...user, 
          body: text, 
          attachment, 
          replyTo: (chatContext.replyTo) ? JSON.stringify(chatContext.replyTo) : "" ,
          chatId: (chatContext.chatId) ? chatContext.chatId : null,
        }
      ).then(async response => {
        if(response.status === 1) {
          //do the cleaning here
          setText('')
          chatContext.setReplyTo(null);
          clearAttachment();
          //retrieve messages
          await chatContext.getChatData().then(data => {
            if(data) {
              chatContext.setChatData(data);
              setTimeout(() => {
                chatContext.scrollToMessage(JSON.parse(data.messages).length - 1)
              }, 1000)
            }
          })
        } else {
          appContext.tellError(response.msg);
        }
      })
      appContext.setShowOverlayLoader(false);
      //unlock typing
      setLockKeyboard(false);
    } else {
      appContext.tellError('Empty message');
    }

  }

  const clearAttachment = () => {
    document.getElementById('__attachment_holder').src = '';
    document.getElementById('__chat_attachment_').value = null;
    setShowHolder(false);
  }

  const loadAttachment = (e) => {
    let img = e.target.files[0];
    if(img) {
      setShowHolder(true);
      let fileReader = new FileReader();
      fileReader.readAsDataURL(img)
      fileReader.onload = function () {
        document.getElementById('__attachment_holder').src = fileReader.result;
      }
    } else {
      
    }
  }

  const goToRecent = () => {
    chatContext.scrollToMessage(JSON.parse(chatContext.chatData.messages).length - 1)
  }

  const writeMessage = (text) => {
    if(!lockKeyboard) {
      setText(text);
    }
  }

  const selectAttachment = () => {
    document.getElementById('__chat_attachment_').click();
  }

  

  return (
    <>
      <div className='ReplyToHolder' data-support-attachment={showHolder} data-m-active={!!chatContext.replyTo}>
        {
          (chatContext.replyTo) ?
          <div className='container d-flex justify-content-between text-redish'>
            <h6 onClick={() => chatContext.scrollToMessage(chatContext.replyTo.id)} className='align-self-center mNoMargin mNoPad font-light mOneLineText' style={{ fontSize: "14px", cursor: "pointer" }}>Replying to {chatContext.replyTo.username}</h6>
            <MdOutlineCancel onClick={() => { chatContext.setReplyTo(null) }} size={30} className='align-self-center' style={{ flexBasis: "35px", flexShrink: "0", cursor: "pointer" }}/>
          </div> : ""
        }
      </div>
      <div className='ChatAttachment text-center' data-m-active={showHolder}>
        <button 
          className='mClearBtn btn btn-dark'
          onClick={clearAttachment}
        >
          Delete
        </button>
        <div className='container'>
          <img id='__attachment_holder' height="100%" width="auto"/>
        </div>
      </div>
      
      <div className="TypingBox2">
        <input hidden id='__chat_attachment_' onChange={loadAttachment} type='file' accept='image/*' />
        <div className='container' style={{ height: "100%" }}>
          <div className="d-flex" style={{ height: "100%" }}>
            <div className='mNoMargin flex-grow-1'>
              <textarea
                  placeholder="Text here...."
                  onChange={(e) => { writeMessage(e.target.value) }}
                  className="mNoMargin"
                  value={text}
                />
            </div>
            <AiOutlineCaretDown  onClick={goToRecent} size={20} className="align-self-center text-goldish" style={{ marginRight: "5px", marginLeft: "5px", cursor: "pointer", flexShrink: "0", flexBasis: "20px" }}/>
            <RiAttachment2  onClick={selectAttachment} size={28} color="var(--goldish)" className="align-self-center" style={{ marginRight: "5px", marginLeft: "5px", cursor: "pointer", flexShrink: "0", flexBasis: "30px" }}/>
            <TbSend  onClick={sendMessage} size={28} color="var(--goldish)" className="align-self-center" style={{ marginRight: "5px", marginLeft: "5px", cursor: "pointer", flexShrink: "0", flexBasis: "30px" }}/>

          </div>
        </div>
      </div>
    </>
  )
}
